export const FETCH_VEHICLE_DETAILS = 'FETCH_VEHICLE_DETAILS'
export const FETCH_VEHICLE_DETAILS_COMPLETE = 'FETCH_VEHICLE_DETAILS_COMPLETE'
